export default "__VITE_ASSET__cYL5uQsb__"